<template>
    <svg xmlns="http://www.w3.org/2000/svg"
         :width="width"
         :height="height"
         :viewBox="viewBox"
         :aria-labelledby="iconName"
         :fill="color"
         role="presentation"
         v-on="$listeners">
        <title :id="iconName"
               lang="en">{{ iconName }} icon</title>
        <slot />
    </svg>
</template>

<script>
import iconProps from './iconProps.js';
export default {
    props: iconProps
};
</script>

<style scoped>
svg {
    display: inline-block;
    vertical-align: baseline;
}
</style>